import { chapters, sceneByRoute, scenes } from './content'
import { useLinkInterceptor, useRoute, useScrollReset } from './router/useRoute'
import { usePresentation } from './presentation/usePresentation'
import { Stage } from './presentation/Stage'
import { ChapterPage, Footer, Header, HomePage, SceneArticle } from './components/Explore'

export default function App() {
  const { path } = useRoute()
  useLinkInterceptor()
  useScrollReset(path, sceneByRoute.get(path)?.id)
  const presentation = usePresentation(path)

  if (presentation.active) {
    return <Stage presentation={presentation} />
  }

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header path={path} onStartPresentation={() => presentation.enter(path)} />
      <main id="main">{renderRoute(path, () => presentation.enter(path))}</main>
      <Footer />
    </>
  )
}

function renderRoute(path: string, onStartPresentation: () => void) {
  if (path === '/' || path === '') {
    return <HomePage onStartPresentation={onStartPresentation} />
  }

  /* An exact scene route renders that scene in the context of its chapter. */
  const scene = sceneByRoute.get(path)
  if (scene) {
    if (scene.chapter === 'opening' || scene.chapter === 'closing') {
      return (
        <div className="shell singlescene">
          <SceneArticle scene={scene} index={scenes.indexOf(scene)} />
        </div>
      )
    }
    return <ChapterPage chapterId={scene.chapter} />
  }

  /* A chapter root. */
  const chapter = chapters.find((c) => c.route === path)
  if (chapter) {
    return <ChapterPage chapterId={chapter.id} />
  }

  return (
    <div className="shell notfound">
      <h1>Page not found</h1>
      <p>
        That route does not exist in this proposal. <a href="/">Return to the opening page</a>.
      </p>
    </div>
  )
}
